import { render, staticRenderFns } from "./AnalysisRequestTable.vue?vue&type=template&id=1a0c0f4b&scoped=true"
import script from "./AnalysisRequestTable.vue?vue&type=script&lang=js"
export * from "./AnalysisRequestTable.vue?vue&type=script&lang=js"
import style0 from "./AnalysisRequestTable.vue?vue&type=style&index=0&id=1a0c0f4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0c0f4b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VIcon,VTooltip})
